/*
 * @Author: changcheng
 * @LastEditTime: 2023-12-22 16:28:03
 */
import { useState } from "react";
import {
  queryActivityCategoryListInfo,
  queryActivityByGXSpecialCourseList,
} from "@root/common/service";
import meetingActiviteByHnImg from "@root/img/meetingActiviteByHn.jpg";
import { Pagination, notification } from "antd";
import { SmileOutlined } from "@ant-design/icons";
import "./_style.scss";
import CourseList from "@root/components/courselist";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "@root/store/index";
import reportQr from "@root/img/reportQr.jpg";
const pageSize = 12;
export default function MeetingActiviteByHn() {
  const { publicSearchKey } = useSelector((state: RootState) => state.userInfo);
  const [treeData, setTreeData] = useState([]);
  const [total, setTotal] = useState(1);
  const [secondCategoryId, setSecondLevelId] = useState<"" | number>("");
  const [courseList, setCourseList] = useState([]);
  const [firstCategoryId, setFirstCategoryId] = useState("");
  // 获取专项
  const queryTrainCourseList = async (param: any, page = 1) => {
    const {
      data: { rows = [], total },
    } = await queryActivityByGXSpecialCourseList(param, {
      pageNum: page,
      pageSize,
    });
    setCourseList(rows);
    setTotal(total);
  };
  /**
   * 处理专项数据
   * @param data
   * @returns
   */
  const handleSpecialData = (data: any) => {
    return data.map((item: { id: number; name: string; children: any[] }) => {
      return {
        label: item.name,
        value: item.id,
        checked: false,
        children: item.children ? handleSpecialData(item.children) : [],
      };
    });
  };
  /**
   * 获取专项分类数据
   */
  const getSpecialClassificationData = async () => {
    const { data = [] } = await queryActivityCategoryListInfo(47);
    setFirstCategoryId(data[0].id);
    setTreeData(handleSpecialData(data));
  };
  useEffect(() => {
    getSpecialClassificationData();
  }, []);
  useEffect(() => {
    firstCategoryId &&
      queryTrainCourseList(
        {
          firstCategoryId: 47,
          secondCategoryId,
          searchValue: publicSearchKey,
        },
        1
      );
  }, [publicSearchKey, firstCategoryId, secondCategoryId]);
  return (
    <div className="course_train_emergency">
      <img src={meetingActiviteByHnImg} alt="" className="banner" />
      <div className="village_radio">
        <h3>课程分类：</h3>
        <p
          className={`${secondCategoryId === "" ? "radio_select" : ""}`}
          onClick={() => {
            // 跳转护理课程
            setSecondLevelId("");
          }}
        >
          全部
        </p>
        {treeData.map(
          (item: { value: number; label: string; children: [] }) => (
            <p
              key={item.value}
              className={`${
                secondCategoryId === item.value ? "radio_select" : ""
              }`}
              onClick={() => {
                setSecondLevelId(item.value);
              }}
            >
              {item.label}
            </p>
          )
        )}
      </div>
      <div>
        <CourseList data={courseList} />
      </div>
      <div className="home_page_container">
        <Pagination
          defaultCurrent={1}
          total={total}
          pageSize={12}
          onChange={(page) => {
            queryTrainCourseList(
              {
                firstCategoryId: 47,
                secondCategoryId,
                searchValue: publicSearchKey,
              },
              page
            );
          }}
          showSizeChanger={false}
        />
      </div>
    </div>
  );
}
